const DEFAULT_OPEN_TIMEOUT_MS = 2800;

export type OpenChallengeInAppOptions = {
  customSchemeUrl: string;
  playStoreUrl: string;
  /** When false, only tries the app deep link (no Play Store redirect). Use in Facebook/Instagram. */
  fallbackToPlayStore?: boolean;
  fallbackDelayMs?: number;
};

/**
 * Opens JustFun when installed (justfun://).
 * Optionally falls back to Play Store if the page stays visible (not in-app browser).
 */
export function openChallengeInApp(options: OpenChallengeInAppOptions): void {
  const {
    customSchemeUrl,
    playStoreUrl,
    fallbackToPlayStore = true,
    fallbackDelayMs = DEFAULT_OPEN_TIMEOUT_MS,
  } = options;

  let leftPage = false;

  const markLeft = () => {
    if (leftPage) return;
    leftPage = true;
  };

  const onBlur = () => markLeft();
  const onVisibility = () => {
    if (document.hidden) markLeft();
  };
  const onPageHide = () => markLeft();

  window.addEventListener('blur', onBlur);
  document.addEventListener('visibilitychange', onVisibility);
  window.addEventListener('pagehide', onPageHide);

  window.location.href = customSchemeUrl;

  if (!fallbackToPlayStore) {
    window.setTimeout(() => {
      window.removeEventListener('blur', onBlur);
      document.removeEventListener('visibilitychange', onVisibility);
      window.removeEventListener('pagehide', onPageHide);
    }, fallbackDelayMs);
    return;
  }

  window.setTimeout(() => {
    window.removeEventListener('blur', onBlur);
    document.removeEventListener('visibilitychange', onVisibility);
    window.removeEventListener('pagehide', onPageHide);
    if (leftPage) return;
    window.location.href = playStoreUrl;
  }, fallbackDelayMs);
}
